/**
 * Aviso de salida cuidada. Aparece cuando el user toca la X con una charla
 * demasiado corta para dejar un debrief útil (pocos turnos del user) pero ya
 * habló algo. En vez de mandar a Home en seco —donde perdería el resumen por
 * cortar antes de tiempo— le ofrece seguir un poco más. Reusa el overlay
 * `drill-overlay` (bottom sheet) de la conversación.
 */
import { useSheetDrag } from '../../hooks/useSheetDrag.js';

interface ShortLeaveSheetProps {
  /** Seguir en la charla (descarta el aviso). También es el tap fuera del sheet. */
  onStay: () => void;
  /** Salir igual (ejecuta la salida real). */
  onLeave: () => void;
}

export function ShortLeaveSheet({ onStay, onLeave }: ShortLeaveSheetProps) {
  const { grabProps, sheetStyle } = useSheetDrag(onStay);
  return (
    <div className="drill-overlay" onClick={onStay}>
      <div className="leave-sheet" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
        <div className="drill-handle sheet-grab" {...grabProps} />
        <div className="leave-sheet-body">
          <div className="leave-sheet-title">¿Salir tan pronto?</div>
          <div className="leave-sheet-sub">
            Todavía es una charla cortita. Con un par de intercambios más te dejo un
            resumen con tu vocabulario y tus correcciones.
          </div>
          <button type="button" className="leave-sheet-stay" onClick={onStay}>
            Seguir practicando
          </button>
          <button type="button" className="leave-sheet-go" onClick={onLeave}>
            Salir igual
          </button>
        </div>
      </div>
    </div>
  );
}
